import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold" }
const _hoisted_2 = { class: "ml-auto w-9 min-w-max rounded-full bg-white px-2.5 py-0.5 text-center font-medium whitespace-nowrap ring-1 ring-gray-200 ring-inset" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FormStat',
  props: {
    icon: {},
    label: {},
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "size-6 shrink-0" })),
    _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.value), 1)
  ]))
}
}

})